import { Component, Input } from "@angular/core";

@Component({
  selector: 'instant-bottom-sheet',
  templateUrl: './instant-bottom-sheet.component.html',
  styleUrls: ['./instant-bottom-sheet.component.scss']
})
export class InstantBottomSheet {
  
  @Input() isDialogOpen: boolean = false;
  
  constructor(
    ) {
  }
}
